<template>
  <app-logged id="EmailsUpdate">
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <div class="mb-6">
                <v-input
                  :messages="[`Responsável pelo email abaixo.`]"
                  prepend-icon="contacts"
                >
                  {{ document[$route.meta.titleAttr] }}
                </v-input>
              </div>
              <v-checkbox
                v-model="email.principal"
                :label="`E-mail principal`"
                on-icon="star"
              />
              <validation-provider
                name="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  type="email"
                  v-model="email.valor"
                  label="E-mail"
                  autocomplete="off"
                  :error-messages="errors[0]"
                />
              </validation-provider>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                v-if="email.id"
                @click.native="remove"
                color="error"
                class="mr-2"
              >
                remover
              </app-button>
              <app-button
                @click.native.prevent="save()"
                :disable="invalid"
              >
                salvar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Store from '../../store'
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import AppButton from '@/components/AppButton'
export default {
  name: 'EmailsUpdate',
  components: {
    AppWidget,
    AppLogged,
    ValidationProvider,
    ValidationObserver,
    AppButton
  },
  data () {
    return {
      document: null
    }
  },
  computed: {
    ...mapGetters(['email'])
  },
  created () {
    this.document = Store.getters[this.$route.meta.documentAttrTelefone]
  },
  methods: {
    ...mapActions(['deleteEmail']),
    goToBack () {
      this.$router.push({
        name: this.$route.meta.routeToBack,
        params: {
          id: this.document.id
        }
      })
    },
    remove () {
      if (
        confirm(
          `${this.$route.meta.titleAlertRemoveEmail}`
        )
      ) {
        this.deleteEmail().then(res => {
          this.goToBack()
        })
      }
    },
    save () {
      this.$refs.observer.validate().then(result => {
        if (result) {
          Store.dispatch(this.$route.meta.actionSaveEmail, {
            key: this.document.id
          }).then(res => {
            this.goToBack()
          })
        }
      })
    }
  },
  mounted () {}
}
</script>
